import React from "react";
import QuotationTabsComponent from "./quotation-tabs.component";

const QuotationTabsContainer = ({ clicked, tabChanged }: any) => {
  return <QuotationTabsComponent clicked={clicked} tabChanged={tabChanged} />;
};

export default QuotationTabsContainer;
